import { client } from '../../axios/client';
import { required } from '../../utils/validation-campaigns.utils';
import { normalizePaginatedResponse } from '../../utils/pagination-campaigns.utils';

export const getTemplatesCatalog = async ({
  idCustomer,
  token,
  offset = 0,
  limit = 20,
  name,
  category, 
}) => {
  required(idCustomer, 'id_customer');
  required(token, 'access token');

  const params = {
    with_params: true,
    offset,
    limit,
  };

  if (name) {
    params.name = name;
  }

  if (category) {
    params.category = category;
  }

  const { data } = await client.get(`/templates/${idCustomer}`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });

  return normalizePaginatedResponse(data, offset, limit);
};